import {Field} from 'formik';
import {I18n} from '@aws-amplify/core';

import {
    FormikNumberInput,
    PlatformFieldset
} from '@flexinet/ui-components';
import {Container} from "@mantine/core";
import {ProductFeaturesAutocomplete} from '../../product-features/inputs/ProductFeaturesAutocomplete';


// Required markers match RecordSchema: the feature is required, the position is not
// (`position: Int` is nullable in CreateProductLineItemInput and UpdateProductLineItemInput).
export const FormComponent = () => {


    return (
        <Container>
            <PlatformFieldset legend={I18n.get('Product Feature')}>
                <Field
                    name='productFeatureId'
                    label={I18n.get('Product Feature')}
                    description={I18n.get('The feature this line item adds to the product')}
                    component={ProductFeaturesAutocomplete}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='position'
                    label={I18n.get('Position')}
                    description={I18n.get('Where the feature appears in the product\'s feature list')}
                    component={FormikNumberInput}
                    my={'xl'}
                />


            </PlatformFieldset>
        </Container>
    );
};
